import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, Grid } from '@chatterbug/aaron'

const SchedulePageSkeleton = ({
  titleSection,
  creditReminderSection,
  nudgeCardSection,
  subtitleSection,
  calendarSection,
  upcomingLessonsSection,
  tutorListSection,
}) => {
  return (
    <Grid gridGap="3x" as="section" className="clevel">
      <Grid
        gridGap="1x"
        columns={{ _: '1fr', tablet: '1fr auto' }}
        justifyItems="start"
        alignItems="center"
      >
        <Box as="h1" variant="text.h3" mb={nudgeCardSection ? '0' : '2x'}>
          {titleSection}
        </Box>
        {creditReminderSection}
      </Grid>
      {nudgeCardSection}
      {subtitleSection}
      <Grid gridGap="6x">
        {upcomingLessonsSection}
        {tutorListSection}
        {calendarSection}
      </Grid>
    </Grid>
  )
}

SchedulePageSkeleton.propTypes = {
  titleSection: PropTypes.any,
  subtitleSection: PropTypes.any,
  creditReminderSection: PropTypes.any,
  tutorListSection: PropTypes.any,
  calendarSection: PropTypes.any,
  upcomingLessonsSection: PropTypes.any,
  nudgeCardSection: PropTypes.any,
}

export default SchedulePageSkeleton
